import {
	ReadonlyRefObject,
	RefObject,
	useRef
} from "react";

export function useSynchronizedRef<T>(
	value: T
): ReadonlyRefObject<T> {
	const ref: RefObject<T> = useRef<T>(value);
	ref.current = value;
	return ref;
}